"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7035],{

/***/ 44599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Animation_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78029);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32567);
// Generated by ReScript, PLEASE EDIT WITH CARE






var card = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .merge */ .TSy([
    _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Styles.body */ .z.body,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("relative")
    ])
]);
var photo = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("relative"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zIndex */ .W5D(1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("img", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8("auto"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("block")
    ])
]);
var text = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexDirection */ .Me8("column"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .justifyContent */ .KlP("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textAlign */ .ydu("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .padding */ .o3D(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.25)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundColor */ .Czw(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rgba */ .m4f(227, 11, 23, {
        NAME: "num",
        VAL: 0.75
    })),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Personal.white */ .RL.white),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .opacity */ .Ohi(0),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionProperty */ .n_e("opacity"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionDuration */ .nVE(_theme_Theme_Animation_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .regular */ .oN),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionTimingFunction */ .BdG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .cubicBezier */ ._s1(0.4, 0, 0.2, 1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionDelay */ .BFP(0),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .position */ .FKU("absolute"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zIndex */ .W5D(2),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .left */ .t$v("zero"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .top */ .wey("zero"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .boxSizing */ .ixg("borderBox"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("&:hover", [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .opacity */ .Ohi(1)
    ])
]);
var name = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textTransform */ .QxZ("uppercase"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue2("bold"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin3 */ .F86("zero", "zero", _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1.25))
]);
var title = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin */ .e6$("zero")
]);
var Styles = {
    card: card,
    photo: photo,
    text: text,
    name: name,
    title: title
};
function BoardOfDirectorsCard(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("p", {
                            children: props.name,
                            className: name
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("p", {
                            children: props.title,
                            className: title
                        })
                    ],
                    className: text
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
                    children: props.photo,
                    className: photo
                })
            ],
            className: card
        })
    });
}
var make = BoardOfDirectorsCard;
 /* card Not a pure module */ 


/***/ }),

/***/ 96705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ BoardOfDirectorsCarousel_bs_make; }
});

// UNUSED EXPORTS: CarouselArrows, Settings, Styles

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/utils/dom.js + 1 modules
var dom = __webpack_require__(1936);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/utils/utils.js
var utils = __webpack_require__(69759);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/components/navigation/navigation.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = (0,utils/* createElementIfNotDefined */.Up)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = (0,dom/* default */.Z)(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = (0,dom/* default */.Z)(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    (0,utils/* extend */.l7)(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ var navigation_navigation = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,utils/* bindModuleMethods */.cR)(swiper, {
      navigation: _extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !(0,dom/* default */.Z)(targetEl).is($prevEl) && !(0,dom/* default */.Z)(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(74124);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/esm/react/swiper.js + 10 modules
var swiper = __webpack_require__(56355);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Js_Core.bs.js
var Css_Js_Core_bs = __webpack_require__(32885);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowLeft.js
var faArrowLeft = __webpack_require__(55346);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowRight.js
var faArrowRight = __webpack_require__(50906);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/BoardOfDirectors/BoardOfDirectorsCarousel__Arrows.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var buttons = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex")
]);
var BoardOfDirectorsCarousel_Arrows_bs_button = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* rem */.hOB(2)),
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* rem */.hOB(2)),
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.white */.RL.white),
    BsCssJs_bs/* justifyItems */.eYb("center"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* transitionProperty */.n_e("box-shadow"),
    BsCssJs_bs/* transitionDuration */.nVE(300),
    BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
    BsCssJs_bs/* boxShadow */.Wnp(Css_Js_Core_bs/* Shadow.box */.jXB.box(BsCssJs_bs.px(0), BsCssJs_bs.px(20), BsCssJs_bs.px(25), BsCssJs_bs.px(-5), undefined, BsCssJs_bs/* rgba */.m4f(0, 0, 0, {
        NAME: "percent",
        VAL: 4.0
    }))),
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs/* pct */.hdZ(100)),
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed),
    BsCssJs_bs/* borderWidth */.J4J("zero"),
    BsCssJs_bs/* cursor */.ocY("pointer"),
    BsCssJs_bs/* selector */.nZE("&:focus", [
        BsCssJs_bs/* outlineWidth */.bu0("zero")
    ]),
    BsCssJs_bs/* selector */.nZE("&:hover", [
        BsCssJs_bs/* boxShadow */.Wnp(Css_Js_Core_bs/* Shadow.box */.jXB.box(BsCssJs_bs.px(0), BsCssJs_bs.px(4), BsCssJs_bs.px(6), BsCssJs_bs.px(-1), undefined, BsCssJs_bs/* rgba */.m4f(0, 0, 0, {
            NAME: "percent",
            VAL: 6.0
        })))
    ])
]);
var buttonPrev = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs/* rem */.hOB(0.75))
]);
var buttonNext = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs/* rem */.hOB(0.75))
]);
var Styles = {
    buttons: buttons,
    button: BoardOfDirectorsCarousel_Arrows_bs_button,
    buttonPrev: buttonPrev,
    buttonNext: buttonNext
};
function BoardOfDirectorsCarousel__Arrows(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx("button", {
                    children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                        icon: faArrowLeft/* faArrowLeft */.ac
                    }),
                    className: classnames_default()([
                        props.prevArrowClass,
                        BoardOfDirectorsCarousel_Arrows_bs_button,
                        buttonPrev
                    ]),
                    onClick: function onClick(e) {
                        e.preventDefault();
                    }
                }),
                jsx_runtime.jsx("button", {
                    children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                        icon: faArrowRight/* faArrowRight */.eF
                    }),
                    className: classnames_default()([
                        props.nextArrowClass,
                        BoardOfDirectorsCarousel_Arrows_bs_button,
                        buttonNext
                    ]),
                    onClick: function onClick(e) {
                        e.preventDefault();
                    }
                })
            ],
            className: buttons
        }),
        className: className$1
    });
}
var make = BoardOfDirectorsCarousel__Arrows;
 /* buttons Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(73063);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/BoardOfDirectors/BoardOfDirectorsCarousel.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE










var buttonDisabled = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* opacity */.Ohi(0.3),
    BsCssJs_bs/* cursor */.ocY("notAllowed"),
    BsCssJs_bs/* pointerEvents */.kkJ("none")
]);
var BoardOfDirectorsCarousel_bs_Styles = {
    buttonDisabled: buttonDisabled
};
var breakpoints = js_dict/* fromList */.hy({
    hd: [
        "0",
        {
            slidesPerView: 1.0,
            spaceBetween: 0,
            slidesPerGroup: 1
        }
    ],
    tl: {
        hd: [
            "420",
            {
                slidesPerView: 2.3,
                spaceBetween: 0,
                slidesPerGroup: 1
            }
        ],
        tl: {
            hd: [
                "480",
                {
                    slidesPerView: 2.3,
                    spaceBetween: 0,
                    slidesPerGroup: 1
                }
            ],
            tl: {
                hd: [
                    "550",
                    {
                        slidesPerView: 2.3,
                        spaceBetween: 0,
                        slidesPerGroup: 1
                    }
                ],
                tl: {
                    hd: [
                        "600",
                        {
                            slidesPerView: 2.3,
                            spaceBetween: 0,
                            slidesPerGroup: 1
                        }
                    ],
                    tl: {
                        hd: [
                            "640",
                            {
                                slidesPerView: 3.3,
                                spaceBetween: 0,
                                slidesPerGroup: 1
                            }
                        ],
                        tl: {
                            hd: [
                                "700",
                                {
                                    slidesPerView: 3.3,
                                    spaceBetween: 0,
                                    slidesPerGroup: 1
                                }
                            ],
                            tl: {
                                hd: [
                                    "850",
                                    {
                                        slidesPerView: 3.5,
                                        spaceBetween: 0,
                                        slidesPerGroup: 1
                                    }
                                ],
                                tl: {
                                    hd: [
                                        "950",
                                        {
                                            slidesPerView: 3.9,
                                            spaceBetween: 0,
                                            slidesPerGroup: 1
                                        }
                                    ],
                                    tl: {
                                        hd: [
                                            "1000",
                                            {
                                                slidesPerView: 3.9,
                                                spaceBetween: 0,
                                                slidesPerGroup: 1
                                            }
                                        ],
                                        tl: {
                                            hd: [
                                                "1050",
                                                {
                                                    slidesPerView: 3.1,
                                                    spaceBetween: 0,
                                                    slidesPerGroup: 1
                                                }
                                            ],
                                            tl: {
                                                hd: [
                                                    "1150",
                                                    {
                                                        slidesPerView: 3.5,
                                                        spaceBetween: 0,
                                                        slidesPerGroup: 1
                                                    }
                                                ],
                                                tl: {
                                                    hd: [
                                                        "1300",
                                                        {
                                                            slidesPerView: 4.3,
                                                            spaceBetween: 0,
                                                            slidesPerGroup: 1
                                                        }
                                                    ],
                                                    tl: {
                                                        hd: [
                                                            "1450",
                                                            {
                                                                slidesPerView: 4.3,
                                                                spaceBetween: 0,
                                                                slidesPerGroup: 1
                                                            }
                                                        ],
                                                        tl: {
                                                            hd: [
                                                                "1600",
                                                                {
                                                                    slidesPerView: 4.8,
                                                                    spaceBetween: 0,
                                                                    slidesPerGroup: 1
                                                                }
                                                            ],
                                                            tl: {
                                                                hd: [
                                                                    "1750",
                                                                    {
                                                                        slidesPerView: 5.3,
                                                                        spaceBetween: 0,
                                                                        slidesPerGroup: 1
                                                                    }
                                                                ],
                                                                tl: {
                                                                    hd: [
                                                                        "1900",
                                                                        {
                                                                            slidesPerView: 5.5,
                                                                            spaceBetween: 0,
                                                                            slidesPerGroup: 1
                                                                        }
                                                                    ],
                                                                    tl: {
                                                                        hd: [
                                                                            "2050",
                                                                            {
                                                                                slidesPerView: 6.0,
                                                                                spaceBetween: 0,
                                                                                slidesPerGroup: 1
                                                                            }
                                                                        ],
                                                                        tl: /* [] */ 0
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var Settings = {
    breakpoints: breakpoints
};
function BoardOfDirectorsCarousel(props) {
    var arrowStyles = props.arrowStyles;
    var arrowStyles$1 = arrowStyles !== undefined ? arrowStyles : "";
    curry._1(core_class/* default.use */.Z.use, [
        navigation_navigation
    ]);
    var navigation = {
        nextEl: ".navigation-next",
        prevEl: ".navigation-prev",
        hideOnClick: false,
        disabledClass: buttonDisabled,
        hiddenClass: "",
        lockClass: ""
    };
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(make, {
                prevArrowClass: "navigation-prev",
                nextArrowClass: "navigation-next",
                className: arrowStyles$1
            }),
            jsx_runtime.jsx(swiper/* Swiper */.t, {
                breakpoints: caml_option/* some */.G(breakpoints),
                children: props.children,
                navigation: navigation
            })
        ]
    });
}
var CarouselArrows;
var BoardOfDirectorsCarousel_bs_make = BoardOfDirectorsCarousel;
 /*  Not a pure module */ 


/***/ }),

/***/ 57458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(7)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("block")
    ])
]);
var Styles = {
    container: container
};
function BoardOfDirectorsList(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            container,
            className$1
        ])
    });
}
var make = BoardOfDirectorsList;
 /* container Not a pure module */ 


/***/ })

}]);